module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "listview"
  }, [_c('transition-group', {
    staticClass: "flex-container",
    attrs: {
      "name": "el-fade-in",
      "tag": "span"
    }
  }, _vm._l((_vm.filteredPosts), function(p, index) {
    return _c('article', {
      key: p['.key']
    }, [_c('el-card', {
      staticClass: "box-card",
      attrs: {
        "body-style": "height:inherit;padding:0px"
      }
    }, [_c('postsummary', {
      attrs: {
        "title": p.name,
        "subtitle": (p.author || '').split('@')[0] + ' @ ' + p.table + '桌',
        "description": p.desc,
        "table": Number(p.table),
        "postKey": p['.key'],
        "authorId": p.uid,
        "starCount": p.starCount,
        "stars": p.stars,
        "heartCount": p.heartCount,
        "hearts": p.hearts,
        "tags": p.tags,
        "host": p.host
      },
      on: {
        "tagClicked": function($event) {
          _vm.$emit('searchTag', $event)
        }
      }
    })], 1)], 1)
  })), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "custom-class": "larger-dialog",
      "size": "large"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('postdetail', {
    attrs: {
      "post": _vm.getPost(_vm.dialogPostKey),
      "isOpen": _vm.dialogVisible
    },
    on: {
      "closeDialog": function($event) {
        _vm.hideDialog()
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-89a3dee2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/hackingmap/ListView.vue
// module id = 979
// module chunks = 1